import customSelect from 'custom-select';

// setup custom selects
customSelect('.confirmation-tracker__select-container #custom-select', {
  placeholder: 'Select an option',
});

// custom checkbox functionality
function handleCheckboxes() {
  const form = document.getElementById('filter-form');

  if (!form) {
    return;
  }

  const partyCheckboxes = form.querySelectorAll("[data-checkbox-type='party-filter']");

  if (!partyCheckboxes) {
    return;
  }

  partyCheckboxes.forEach((checkbox) => {
    if (checkbox.checked === true) {
      checkbox.setAttribute('tabindex', -1);
      checkbox.parentElement.classList.add('checkbox-disabled');
    }

    // remove class once page is loaded
    checkbox.parentElement.classList.remove('hide-tracker-checkboxes');

    checkbox.addEventListener('change', () => {
      if (!form) {
        return;
      }

      form.submit();
    });
  });

  // get checked checkboxes
  const checkedCheckboxes = Array.from(partyCheckboxes).filter(
    (checkbox) => checkbox.checked === true,
  );

  // if there are two checked checkboxes, enable both checkboxes
  if (checkedCheckboxes.length === 2) {
    checkedCheckboxes.forEach((checkbox) => {
      checkbox.setAttribute('tabindex', 1);
      checkbox.parentElement.classList.remove('checkbox-disabled');
      checkbox.parentElement.classList.add('both-checked');
    });
  }
}

// senator modals
function modals() {
  const triggerButtons = document.querySelectorAll('.modalBtn');
  const modal = document.querySelector('dialog');

  if (!triggerButtons || !modal) {
    return;
  }

  const modalContent = modal.querySelector('#modal-js-content-wrap');

  if (!modalContent) {
    return;
  }

  // handle opening modals
  const confirmationTrackerContainer = document.querySelector('.confirmation-tracker');

  if (!confirmationTrackerContainer) {
    return;
  }

  confirmationTrackerContainer.addEventListener('click', senatorClick);

  // click modalclose element to close dialog
  modal.querySelector('.modalclose').addEventListener('click', () => {
    // Reset modal content.
    handleModalClose(modal, modalContent);
  });

  // handle closing modals when pressing escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      // Reset modal content.
      handleModalClose(modal, modalContent);
    }
  });

  // handle closing modals when clicking outside of box
  document.addEventListener('click', ({ target }) => {
    if (target !== modal) return;
    // Reset modal content.
    handleModalClose(modal, modalContent);
  });
}

function renderModalContent(senatorId) {
  // get senator id, remove hash symbol from it, and save it to a variable
  senatorId = senatorId ?? window.location.hash.replace('#', '');

  // if the senatorId is not present in the hash, return
  if (!senatorId) return;

  // otherwise, render the modal content
  const modal = document.querySelector('dialog');

  if (!modal) {
    return
  }

  const modalContent = document.querySelector(`#modal-content-${senatorId}`);
  const modalContentWrap = modal.querySelector('#modal-js-content-wrap');

  if (!modalContent || !modalContentWrap) return;
  // Replace content
  // Clone node and then append it to the modal
  const modalContentClone = modalContent.cloneNode(true);
  modalContentWrap.appendChild(modalContentClone);
  modal.showModal();

  // Disable body scroll when modal is open
  document.body.style.overflow = 'hidden';

  // Detect scrollbar width and add padding to prevent layout shift
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function senatorClick(e) {
  if (e.target.closest('.modalBtn')) {
    const senatorId = e.target.closest('.modalBtn').dataset.figureid;
    if (!senatorId) return;
    renderModalContent(senatorId);
    history.replaceState(null, null, `#${senatorId}`);
  }
}

function handleModalClose(modal, modalContent) {
  if (!modal || !modalContent) {
    return;
  }

  modal.close();
  modalContent.replaceChildren();
  history.replaceState(null, null, window.location.pathname);

  // Enable body scroll again
  document.body.style.overflow = 'auto';
  document.body.style.paddingRight = ''; // Reset padding-right
}

// run on load so we can render the modal if there is a senator id hash in the url
window.addEventListener('load', () => {
  renderModalContent();
});

// combined init function
const initVoteTracker = () => {
  if (!document.querySelector('#senator-confirmation-vote-tracker')) {
    return;
  }

  modals();
  handleCheckboxes();
}


if (document.readyState !== 'complete') {
  document.addEventListener('DOMContentLoaded', initVoteTracker);
} else {
  initVoteTracker();
}
